<template lang="pug">
  .procurement-final-scoped
    title-bar {{ $t('SOW') }}
    div(style="margin-left: 20px")
      upload-multiple-file(
        text="附件"
        :fileName="brief.brief_name"
        :downloadUrl="brief.brief_download_url"
        :files="brief.brief_name_list"
        :isRequired="false"
      )
      el-row
        el-col(:span="4") {{ $t('介绍') }}
        el-col(:span="12")
          display-text-container(:text="brief.remark")
      Category(:data="scope")
      el-row(v-if="kpi")
        el-col(:span="4") {{ $t('KPI目标') }}
        el-col(:span="12")
          kpi-view(:data="kpi")
</template>

<script>
import TitleBar from '@/components/TitleBar'
import Category from '@/components/Category'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import { numberWithPercent, numberWithCommas } from '@/umcc/util'
import KpiView from '@/components/KpiView'
import DisplayTextContainer from '@/components/DisplayTextContainer'

export default {
  components: {
    Category,
    TitleBar,
    UploadMultipleFile,
    KpiView,
    DisplayTextContainer
  },
  props: {
    brief: {
      type: Object,
      default () {
        return {}
      }
    },
    scope: {
      type: Array,
      default () {
        return []
      }
    },
    kpi: {
      type: Array,
      default () {
        return null
      }
    }
  },
  filters: {
    numberWithPercent,
    numberWithCommas
  }
}
</script>
